<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">材料盘存损益异常情况登记</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <material-inventory ref="create" :userData="userData" :formByFather="form"></material-inventory>

          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交材料盘点登记</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  // import Attachments from '@/components/Attachments'
  // import ApprovalItem from '@/components/ApprovalItem'

  import MaterialInventory from '@/page/form/materialInventory'
  export default {
    components: {
      // ApprovalItemByCustom,
      MaterialInventory,
      // ApprovalItem,
      // Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          houseId: '',
          projectId: '',
          customer: '',
          materials: [],
          time: '',
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.params.houseId && this.$route.params.houseId != 0) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      if (this.$route.params.projectId) {
        this.form.projectId = this.$route.params.projectId / 1
      }
      this.form.time = this.getNowTime()
    },
    methods: {
      plusZero(s) {
        return s < 10 ? '0' + s : s;
      },
      getNowTime() {
        let _s = ""
        let _time = new Date()
        _s += _time.getFullYear() + "-"
        _s += this.plusZero(_time.getMonth() + 1) + "-"
        _s += this.plusZero(_time.getDate()) + " "
        _s += this.plusZero(_time.getHours()) + ":"
        _s += this.plusZero(_time.getMinutes()) + ":"
        _s += "00"
        return _s
      },
      // 提交材料盘点
      SubmitMaterial() {
        this.form = this.$refs.create.getFromData()

        // this.form.approvalType = this.approvalType
        // this.form.approvalUserIds = this.$refs.approval.getUserIds()
        // if (!this.form.approvalUserIds) {
        //   this.$message.error('审批人员不能一个都不选择')
        //   return
        // }
        // this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        // let _url = !this.form.applyId ? '/storage/material/use' : '/storage/material/use/edit?applyId=' + this.form.applyId

        ajax.post('/storage/material/pan', this.form, (res) => {
          this.formLoading = false
          this.$message.success('提交盘点情况成功')
          this.$router.push('/Storage/MaterialInventoryList/' + this.form.houseId)
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/materialInventory.vue